<template>
  <div>
    <el-row>
      <el-col :span="24">
        <el-card>
          <div slot="header" class="flex justify-between">
            <span>拼团信息</span>
          </div>
          <div class="card-body">
            <el-form label-width="100px">
              <el-form-item label="商品">
                <el-col :span="23">
                  <el-input 
                    v-model="formData.prodName" 
                    disabled 
                    placeholder="必填，请填写商品名称"
                  />
                </el-col>
              </el-form-item>

              <el-form-item label="拼团名称">
                <el-col :span="11">
                  <el-input 
                    v-model="formData.groupProdName" 
                    placeholder="必填，请填写拼团名称"
                  />
                </el-col>
                <el-col :span="11" :offset="2">
                  <el-input 
                    v-model="formData.sort" 
                    placeholder="必填，请填写拼团排序"
                  />
                </el-col>
              </el-form-item>

              <el-form-item label="拼团简介">
                <el-col :span="23">
                  <el-input
                    type="textarea"
                    v-model="formData.groupProdDesc"
                    placeholder="必填，请填写拼团简介"
                    maxlength="250"
                    show-word-limit
                    rows="4"
                  />
                </el-col>
              </el-form-item>
            </el-form>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24">
        <el-card>
          <div slot="header" class="flex justify-between">
            <span>商品规格</span>
          </div>
          <div class="card-body">
            <el-table :data="formData.productSpecs" border>
              <el-table-column prop="specName" label="规格名称" align="center" />
              <el-table-column label="规格值" align="center">
                <template slot-scope="scope">
                  <span v-html="scope.row.specValue"></span>
                </template>
              </el-table-column>
              <el-table-column prop="stock" label="库存" align="center" />
              <el-table-column prop="sales" label="销量" align="center" />
              <el-table-column prop="price" label="金额" align="center" />
              <el-table-column prop="costPrice" label="成本价" align="center" />
              <el-table-column label="拼团价" align="center">
                <template slot-scope="scope">
                  <el-input-number 
                    v-model="scope.row.groupPrice" 
                    :min="0" 
                    :precision="2"
                    controls-position="right"
                  />
                </template>
              </el-table-column>
              <el-table-column label="拼团库存" align="center">
                <template slot-scope="scope">
                  <el-input-number 
                    v-model="scope.row.groupStock" 
                    :min="0" 
                    :precision="0"
                    controls-position="right"
                  />
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-card>
      </el-col>
    </el-row>

    <el-row>
      <el-col :span="24">
        <el-card>
          <div slot="header" class="flex justify-between">
            <span>商品扩展</span>
          </div>
          <div class="card-body">
            <el-form label-width="100px">
              <el-form-item label="活动状态">
                <el-col :span="11">
                  <el-select 
                    v-model="formData.state" 
                    placeholder="选填，请选择状态"
                    style="width:100%"
                  >
                    <el-option label="开启" value="1001" />
                    <el-option label="关闭" value="2002" />
                  </el-select>
                </el-col>
                <el-col :span="11" :offset="2">
                  <el-input 
                    v-model="formData.userCount" 
                    placeholder="必填，请填写拼团人数"
                  />
                </el-col>
              </el-form-item>

              <el-form-item label="商品详情">
                <el-col :span="23">
                  <tinymce 
                    v-model="formData.content" 
                    :height="300"
                  />
                </el-col>
              </el-form-item>
            </el-form>

            <div class="footer-buttons">
              <el-button type="warning" @click="closeEditProduct">
                <i class="el-icon-close"></i>取消
              </el-button>
              <el-button type="primary" @click="updateProductInfo">
                <i class="el-icon-check"></i>保存
              </el-button>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { updateGroupBuyProduct, getGroupBuyProductDetail } from '@/api/goods/groupBuyProductApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'EditGroupBuyProduct',
  props: {
    productData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      formData: {
        groupId: '',
        productId: '',
        groupProdName: '',
        prodName: '',
        groupProdDesc: '',
        sort: '',
        content: '',
        state: '',
        userCount: '3',
        productSpecs: []
      }
    }
  },
  methods: {
    open(product) {
      console.log(product)
      this.loadProductDetail(product.groupId)
    },
    async loadProductDetail(groupId) {
      try {
        const res = await getGroupBuyProductDetail({ groupId })
        this.formData = {
          ...res.data,
          productSpecs: res.data.groupBuyProductSpecs.map(item => ({
            ...item,
            specValue: item.productSpecDetails.map(detail => detail.detailValue).join('/')
          }))
        }
      } catch (error) {
        console.error('获取拼团商品详情失败:', error)
      }
    },
    validateForm() {
      if (!this.formData.groupProdName) {
        this.$message.error('拼团名称不能为空')
        return false
      }
      if (!this.formData.groupProdDesc) {
        this.$message.error('拼团简介不能为空')
        return false
      }
      if (!this.formData.userCount) {
        this.$message.error('拼团人数不能为空')
        return false
      }
      return true
    },
    async updateProductInfo() {
      if (!this.validateForm()) return

      try {
        const params = {
          ...this.formData,
          shopId: getShopId()
        }
        await updateGroupBuyProduct(params)
        this.$message.success('修改成功')
        this.closeEditProduct()
        this.$emit('close')
      } catch (error) {
        console.error('修改拼团商品失败:', error)
      }
    },
    closeEditProduct() {
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.card-body {
  padding: 20px;
}
.footer-buttons {
  margin-top: 20px;
  text-align: right;
}
</style>